import { useMemo, useState } from 'react';

import { BlockStepManagerContext } from './blockStepManager.context';
import { BlockStepManagerState } from './blockStepManager.types';

interface BlockStepManagerProviderProps {
	children: React.ReactNode;
}

export const BlockStepManagerProvider = ({ children }: BlockStepManagerProviderProps) => {
	const [state, setState] = useState<BlockStepManagerState>({});

	const value = useMemo(() => {
		return {
			...state,
			setState,
		};
	}, [state, setState]);

	return <BlockStepManagerContext.Provider value={value}>{children}</BlockStepManagerContext.Provider>;
};
